import { render, staticRenderFns } from "./templates.vue?vue&type=template&id=421eee5e&"
import script from "./templates.vue?vue&type=script&lang=ts&"
export * from "./templates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports